import React, { FC } from 'react';
import {
  Input,
  Box,
  Text,
  Center,
  Select,
  Container,
  Stack,
  Link,
  Grid,
  GridItem,
  AbsoluteCenter,
} from '@chakra-ui/react';

import { ComponentsWithLabel } from '../molecules/ComponentsWithLabel';
import { PageSendButton } from '../atom/button/PageSendButton';
import { DefaultLayout } from '../templates/DefaultLayout';
import { ButtonType, YoyakuSbtKbn } from '../types/teikihoan/commonDefinition';
import { ConfirmationCard } from '../molecules/ConfirmationCard';
import { ModalSpinner } from '../atom/spinner/ModalSpinner';
import { CommonDialog } from '../atom/dialog/CommonDialog';
import { AlertWithIcon } from '../atom/alert/AlertWithIcon';
import { useResevation } from '../hooks/useResevation';

export const InputResevationNo: FC = () => {
  const {
    yoyakuSbtList,
    yoyakuSearchInfo,
    customerInfo,
    errorMsg,
    getDataMsg,
    isLoading,
    digOpen,
    yoyakuIsToday,
    displayRirekiLink, // 2024.09 COMTEC kawaji ADD
    handlePrevClick,
    handleGetYoyakuInfo,
    handleYoyakuChange,
    handleCancelClick,
    onYoyakuCancel,
    handleSelectChange,
    handleInputChange,
    setDigOpen,
  } = useResevation();

  return (
    <>
      <DefaultLayout>
        <Container maxW="container.md">
          <CommonDialog
            title="予約のキャンセル"
            message={
              <>
                予約をキャンセルします。
                <br />
                よろしいですか？
              </>
            }
            buttonType={ButtonType.YesNo}
            isOpen={digOpen}
            onAccept={onYoyakuCancel}
            onClose={() => setDigOpen(false)}
          />

          {/* 2024.09 COMTEC kawaji MOD START */}
          {/* <form onSubmit={handleGetYoyakuInfo}> */}
          <form method="post" action="" onSubmit={handleGetYoyakuInfo}>
            <input type="hidden" name="rollback" value="" />
            {/* 2024.09 COMTEC kawaji MOD END */}
            <Box mt={10}>
              <Text mb={5}>
                ご予約いただいたサービス、受付番号を入力してください。
              </Text>
              <ComponentsWithLabel
                label="サービス"
                chkValue={yoyakuSearchInfo.yoyaku_sbt_cd !== ''}
              >
                <Select
                  placeholder="選択してください"
                  value={yoyakuSearchInfo.yoyaku_sbt_cd}
                  onChange={handleSelectChange}
                >
                  {yoyakuSbtList.map((gyomu) => (
                    <option key={gyomu.key} value={gyomu.key}>
                      {gyomu.name}
                    </option>
                  ))}
                </Select>
              </ComponentsWithLabel>
              <Box>
                <ComponentsWithLabel
                  label="受付番号"
                  chkValue={
                    yoyakuSearchInfo.uketsuke_no !== '' &&
                    yoyakuSearchInfo.uketsuke_no.length === 10
                  }
                >
                  <Input
                    // 2024.09 COMTEC kawaji MOD START
                    //type="tel"
                    type={
                      yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.event
                        ? 'text'
                        : 'tel'
                    }
                    // 2024.09 COMTEC kawaji MOD END
                    placeholder="0000000000"
                    maxLength={10}
                    value={yoyakuSearchInfo.uketsuke_no}
                    onChange={handleInputChange}
                  ></Input>
                  <Box ml={3}>
                    {yoyakuSearchInfo.yoyaku_sbt_cd ===
                    YoyakuSbtKbn.teikihoan ? (
                      <Box>10桁の数字を入力してください。</Box>
                    ) : (
                      <Box>10桁の英数字を入力してください。</Box>
                    )}
                  </Box>
                </ComponentsWithLabel>
              </Box>
              {errorMsg !== '' && (
                <AlertWithIcon status="error" mb={5} text={errorMsg} />
              )}
              <Stack
                direction={['column', 'row-reverse']}
                display={{ md: 'flex' }}
                width={{ base: '100%' }}
              >
                <PageSendButton
                  text="確認"
                  type="submit"
                  margin={1}
                ></PageSendButton>
                <PageSendButton
                  text="戻る"
                  type="button"
                  onClick={handlePrevClick}
                  margin={1}
                ></PageSendButton>
              </Stack>
              {/* </Box> */}
            </Box>
          </form>
          {getDataMsg !== '' && <AlertWithIcon mt={5} text={getDataMsg} />}
          {customerInfo !== null && (
            <Box mt={10}>
              <Text mb={5}>以下の内容でご予約を承っております。</Text>
              <ConfirmationCard
                cardTitle="受付内容"
                cardDetail={customerInfo}
              />
              {/* 2024.09 COMTEC kawaji MOD START */}
              {/* {yoyakuIsToday && (
                <AlertWithIcon
                  status="warning"
                  mt={5}
                  text="申し訳ございませんが、定期保安調査当日の予約変更の受付は電話のみとなります。お手数ですが、日本ガスカスタマーサポート（099-224-5232）までご連絡ください。"
                />
              )} */}
              {yoyakuIsToday.isToday && (
                <AlertWithIcon
                  status="warning"
                  mt={5}
                  text={yoyakuIsToday.text}
                />
              )}
              {/* 2024.09 COMTEC kawaji MOD END */}
              <Center>
                <Stack
                  direction={['column', 'row']}
                  mt={7}
                  display={{ md: 'flex' }}
                  width={{ base: '100%' }}
                >
                  <PageSendButton
                    text="予約を変更する"
                    type="button"
                    margin={1}
                    onClick={handleYoyakuChange}
                    disabled={yoyakuIsToday.isToday} //2024.09 COMTEC kawaji MOD
                  ></PageSendButton>
                  <PageSendButton
                    text="予約をキャンセルする"
                    type="button"
                    margin={1}
                    onClick={handleCancelClick}
                    disabled={yoyakuIsToday.isToday} //2024.09 COMTEC kawaji MOD
                  ></PageSendButton>
                </Stack>
              </Center>
            </Box>
          )}
          {/* 2024.09 COMTEC kawaji ADD START */}
          {yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.event &&
          displayRirekiLink.isDisplay ? (
            <Box position={'relative'}>
              <AbsoluteCenter mt={7}>
                <Link width={'100%'} href={displayRirekiLink.link}>
                  暮らしサービス履歴へ
                </Link>
              </AbsoluteCenter>
            </Box>
          ) : (
            <></>
          )}
          {/* 2024.09 COMTEC kawaji ADD END */}

          <ModalSpinner isOpen={isLoading} />
        </Container>
      </DefaultLayout>
    </>
  );
};
